<template>
  <div class="disclaimer">
    <i v-if="currentRouteName == 'en' || currentRouteName == 'personal-data-policy'">
      This is an international website for the general public (outside the UK and ROI). This information is for general informational and educational purposes only.
    </i>
    <i v-if="currentRouteName == 'fr' || currentRouteName == 'politique-de-donnees-personnelles'">
      Ce site web international est destiné au grand public (en dehors du Royaume-Uni et de la République d'Irlande). Ces informations sont fournies à titre purement informatif et éducatif.
    </i>
  </div>

  <nav class="router">
      <div v-if="currentRouteName == 'personal-data-policy' || currentRouteName == 'politique-de-donnees-personnelles'">
          <router-link to="/personal-data-policy">EN</router-link> |
          <router-link to="/fr/politique-de-donnees-personnelles">FR</router-link>
      </div>
      <div v-else>
          <router-link to="/">EN</router-link> |
          <router-link to="/fr">FR</router-link>
      </div>

      <a v-if="currentRouteName == 'en' || currentRouteName == 'fr'" href="#modal" data-target="#quick-access-menu" class="quick__access d-none d-md-flex flex-column flex-md-row justify-content-end align-items-end align-items-md-center
            pe-3 text-decoration-none position-relative py-md-3">
          <img src="./assets/img/loupe.png" width="19" alt="scroll" class="scroll__down--img mb-1 mb-md-0 me-md-2"/>
          <div class="text-end text-uppercase c-blue f-middle">
              Quick Access
          </div>
      </a>
  </nav>
  <router-view/>
</template>

<script>
    // @ is an alias to /src
    //import global from '../assets/js/app.js';

    export default {
        name: 'app',
        mounted() {
            //global.init();
        },
        computed: {
            currentRouteName() {
                return this.$route.name;
            }
        }
    }
</script>
